import { Menu } from '@headlessui/react';
import { ChevronDownIcon } from '@heroicons/react/20/solid';
import { useState } from 'react';

interface ActionProps {
  title: string;
  onClick: () => void;
}

interface Props {
  dropDownActions?: ActionProps[];
  defaultAction?: ActionProps;
}

export const ActionSelectTabs: React.FC<Props> = ({
  dropDownActions,
  defaultAction,
}) => {
  const [selectedAction, setSelectedAction] = useState(
    defaultAction?.title || 'Assets'
  );

  return (
    <>
      <div className="my-auto space-y-1">
        <label className="block lg:text-sm md:text-sm text-xs font-medium text-primary-700">
          Account Type
        </label>
        <Menu as="div" className="ml-auto">
          <Menu.Button className="rounded-md border-2 border-primary-500 lg:text-base md:text-base text-xs text-primary-500 lg:px-4 lg:py-1 md:px-4 md:py-1 px-2 py-1 hover:text-primary-700">
            <div className="flex items-center space-x-2">
              <span>{selectedAction}</span>
              <ChevronDownIcon width={20} height={20} />
            </div>
          </Menu.Button>
          <Menu.Items className="z-10 absolute space-y-2 mt-0.5 w-48 origin-top-right rounded-md bg-white p-2 lg:text-base md:text-base text-xs font-medium shadow-lg ring-1 ring-gray-900/5 focus:outline-none whitespace-nowrap">
            {dropDownActions?.map((act, index) => (
              <>
                <div className="border-t border-gray-300 my-1" />
                <Menu.Item key={index}>
                  <div
                    onClick={() => {
                      act.onClick();
                      setSelectedAction(act.title);
                    }}
                    className="hover:bg-primary-500 rounded-md cursor-pointer pl-2"
                  >
                    {act.title}
                  </div>
                </Menu.Item>
              </>
            ))}
          </Menu.Items>
        </Menu>
      </div>
    </>
  );
};
